export function getSubEventLabel(subEvent) {
  if (!subEvent) return "Sub Event";

  const title = subEvent.title || subEvent.sub_event_title;
  if (title) return title;

  const location = subEvent.location || subEvent.sub_event_location || "";
  const venue = subEvent.venue || subEvent.sub_event_venue || "";

  if (location && venue) return `${location} - ${venue}`;
  return location || venue || "Sub Event";
}
